module.exports = __webpack_public_path__ + "static/media/mic.93e2db59.svg";